import { Component } from '@angular/core';

@Component({
  selector: 'quotely-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {

}
